export default {
    type: 'news-modules',
    aliases: {
        camel: 'newsModules',
        singular: 'News module',
        plural: 'News modules',
        lowerSingular: 'news module',
        lowerPlural: 'news modules',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
